module.exports = __webpack_public_path__ + "img/process01.c752c31a.svg";